"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactQuill = _interopRequireDefault(require("react-quill"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("react-quill/dist/quill.snow.css");
require("./FormReactQuill.css");
var _reactRedux = require("react-redux");
var _toolkit = require("@reduxjs/toolkit");
var _formSlice = require("../redux/slices/formSlice");
var _lodash = require("lodash");
var _excluded = ["formatFromStore", "formatToStore", "name", "input", "toolbarProps", "placeholder", "maxCharacters"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var fonts = ['Noto', 'Roboto', 'Courier'];
var getFontName = function getFontName(font) {
  return font.toLowerCase().replace(/\s/g, '-');
};
var fontNames = fonts.map(function (font) {
  return getFontName(font);
});
var fontList = [{
  'font': fontNames
}];
var toolbarOptions = [['bold', 'italic', 'underline', 'strike'], ['blockquote', 'code-block'], [{
  'list': 'ordered'
}, {
  'list': 'bullet'
}], [{
  'direction': 'rtl'
}], [{
  'header': [1, 2, 3, 4, 5, 6, false]
}], [{
  'color': []
}, {
  'background': []
}], fontList, [{
  'link': true
}], [{
  'align': []
}], ['clean']];
var Font = _reactQuill["default"].Quill["import"]('formats/font');
Font.whitelist = fontNames;
_reactQuill["default"].Quill.register(Font, true);
var FormRichTextField = function FormRichTextField(props) {
  var reactQuillRef = _react["default"].useRef();
  var _props$formatFromStor = props.formatFromStore,
    formatFromStore = _props$formatFromStor === void 0 ? _lodash.identity : _props$formatFromStor,
    _props$formatToStore = props.formatToStore,
    formatToStore = _props$formatToStore === void 0 ? _lodash.identity : _props$formatToStore,
    nameProp = props.name,
    input = props.input,
    toolbarProps = props.toolbarProps,
    placeholder = props.placeholder,
    maxCharacters = props.maxCharacters,
    rest = _objectWithoutProperties(props, _excluded);
  var dispatch = (0, _reactRedux.useDispatch)();
  var selectValue = (0, _react.useMemo)(function () {
    return (0, _toolkit.createSelector)(function (state) {
      return (0, _lodash.get)(state.form.values, (0, _lodash.toPath)(nameProp));
    }, function (value) {
      return value ? formatFromStore(value) : '';
    });
  }, [nameProp, formatFromStore]);
  var value = (0, _reactRedux.useSelector)(selectValue);
  var onChange = (0, _react.useCallback)(function (e) {
    dispatch((0, _formSlice.setValue)({
      name: nameProp,
      value: formatToStore(e)
    }));
  }, [dispatch, formatToStore, nameProp]);
  var toolbar = document.querySelector('.ql-toolbar');
  if (toolbar) {
    toolbar.addEventListener('mousedown', function (e) {
      e.preventDefault();
    });
  }
  var checkCharacterCount = function checkCharacterCount(event) {
    var editor = reactQuillRef.current.getEditor();
    var unprivilegedEditor = reactQuillRef.current.makeUnprivilegedEditor(editor);
    if ((unprivilegedEditor === null || unprivilegedEditor === void 0 ? void 0 : unprivilegedEditor.getLength()) > maxCharacters && event.key !== 'Backspace') {
      event.preventDefault();
    }
  };
  if (toolbarProps) {
    if (!toolbarProps.includes(fontList)) {
      toolbarProps.push(fontList);
    }
  }
  return /*#__PURE__*/_react["default"].createElement(_reactQuill["default"], _extends({
    modules: {
      toolbar: toolbarProps || toolbarOptions
    },
    placeholder: placeholder || null
  }, rest, input, {
    onKeyDown: maxCharacters && checkCharacterCount,
    ref: reactQuillRef,
    theme: "snow",
    bounds: '#Quill',
    value: value,
    onChange: onChange
  }));
};
FormRichTextField.propTypes = {
  formatFromStore: _propTypes["default"].func,
  formatToStore: _propTypes["default"].func,
  name: _propTypes["default"].string.isRequired,
  input: _propTypes["default"].object,
  toolbarProps: _propTypes["default"].array,
  placeholder: _propTypes["default"].string,
  maxCharacters: _propTypes["default"].number
};
var _default = exports["default"] = FormRichTextField;